import {
  applyMiddleware,
  combineReducers,
  compose,
  legacy_createStore as createStore,
} from "redux";
import thunk from "redux-thunk";
import configurazioneReducer from "./associazione/reducer";
import numeriNeriReducer from "./numeri-neri/reducer";
import messaggiVocaliReducer from "./messaggi-vocali/reducer";
import storicoConfigurazioniReducer from "./storico-configurazioni/reducer";
import regoleDiApplicazioneReducer from "./regole-di-applicazione/reducer";
import altriInstradamentoReducer from "./altri-instradamento/reducer";
import disabilitazioneChiamateReducer from "./gestione-disabilitazione-chiamate/reducer";
import messagiVocaliOrigineReducer from "./messagi-vocali-origine/reducer";
import customersReducer from "./customers/reducer";
import gruppiDiNumeriNeriReducer from "./gruppi-di-numeri-neri/reducer";
import areeDiOrigineChiamateReducer from "./aree-di-origine-chiamate/reducer";
import fasceOrarieReducer from "./fasce-orarie/reducer";
import fileAudioReducer from "./file-audio/reducer";
import listeBiancheReducer from "./liste-bianche/reducer";
import tagManagerReducer from "./tag-manager/reducer";

const composeEnhancers =
  (process.env.NODE_ENV === "development"
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : null) || compose;

const rootReducer = combineReducers({
  configurazioneReducer,
  numeriNeriReducer,
  gruppiDiNumeriNeriReducer,
  areeDiOrigineChiamateReducer,
  messaggiVocaliReducer,
  storicoConfigurazioniReducer,
  regoleDiApplicazioneReducer,
  altriInstradamentoReducer,
  disabilitazioneChiamateReducer,
  messagiVocaliOrigineReducer,
  fasceOrarieReducer,
  customersReducer,
  fileAudioReducer,
  listeBiancheReducer,
  tagManagerReducer,
});

export const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk))
);
